import React, { useState } from 'react';
import styles from '../AssignedJobsSection.module.css';
import { fmtHrs, fmtUSD } from './jobsApi';

// ── Delete confirmation modal ───────────────────────────────────────────────

const JobDeleteModal = ({ job, onCancel, onDeleted, getHeaders, jobsBaseUrl }) => {
    const [deleting, setDeleting] = useState(false);
    const [err, setErr] = useState('');
    const hasAttachedData = Number(job.hours_logged || 0) > 0;

    const handleDelete = async () => {
        setDeleting(true);
        setErr('');
        try {
            const res = await fetch(`${jobsBaseUrl}/${job.job_id}`, { method: 'DELETE', headers: getHeaders() });
            const json = await res.json();
            if (!res.ok || !json.success) throw new Error(json.msg || 'Failed to delete job');
            onDeleted(job.job_id);
        } catch (e) {
            setErr(e.message || 'Failed to delete job.');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div className={styles.moOverlay}>
            <div className={styles.moDim} onClick={onCancel} />
            <div className={styles.modal} style={{ width: 400 }}>
                <div className={styles.modalHdr}>
                    <span className={styles.modalTitle}>Delete job</span>
                    <button className={styles.dClose} onClick={onCancel}>×</button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.deleteCopy}>
                        Delete <strong>JOB-{job.job_id}</strong>? It disappears from the operator's dashboard.
                    </div>
                    {hasAttachedData && (
                        <div className={styles.warnBox}>
                            {fmtHrs(job.hours_logged)} logged hours are attached to this job
                            {job.amount_outstanding > 0 ? `, with ${fmtUSD(job.amount_outstanding)} still outstanding.` : '.'}
                            {' '}Deleting it unlinks associated uploads from the review pipeline.
                        </div>
                    )}
                    {job.order_id != null && (
                        <div className={styles.warnBox}>
                            This job is linked to <strong>ORD-{job.order_id}</strong>. Deleting it will unlink the job from that order.
                        </div>
                    )}
                    {err && <div className={styles.errMsg} style={{ display: 'block' }}>{err}</div>}
                </div>
                <div className={styles.modalFtr}>
                    <button className={styles.btnGhost} onClick={onCancel} disabled={deleting}>Cancel</button>
                    <button className={styles.btnDanger} onClick={handleDelete} disabled={deleting}>
                        {deleting ? 'Deleting…' : 'Delete job'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JobDeleteModal;
